window.addEventListener('scroll', function () {
  const header = document.querySelector('.l_header');
  const fv = document.querySelector('.js-fv');
//  if (window.scrollY > fv.offsetHeight) {
//      header.classList.add('is-active');
//  } else {
//      header.classList.remove('is-active');
//  }

});

const b_newitemListSlider = new Swiper(".b_newitemListSlider", {
    slidesPerView: 1.2,
        spaceBetween: 13,
    loop: true,
    centeredSlides: true,
    speed: 200,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      type: "progressbar", // プログレスバー
    },
    breakpoints: {
      // スライドの表示枚数：500px以上の場合
      768: {
    loop: false,
    centeredSlides: false,
        slidesPerView: 4,
        spaceBetween: 16,
      },
    },
  });